"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaPeriodoEtapa = exports.yupPeriodoEtapa = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupPeriodoEtapa = yup.object({
    idPeriodo: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .required()
        .positive()
        .integer()
        .label('Período'),
    etapa: yup.number().positive().integer().required().default(1).label('Etapa'),
    dataEtapaIni: (0, utils_1.sge2Date)().default(null).nullable().label('Data Inicial'),
    dataEtapaFim: (0, utils_1.sge2Date)().default(null).nullable().label('Data Final'),
    dataFinalDigitacao: (0, utils_1.sge2Date)().default(null).nullable().label('Data Final Digitação Etapa'),
    dataRecuperacaoIni: (0, utils_1.sge2Date)().default(null).nullable().label('Data Recuperação Inicial'),
    dataRecuperacaoFim: (0, utils_1.sge2Date)().default(null).nullable().label('Data Recuperação Final'),
    dataFinalDigitacaoRec: (0, utils_1.sge2Date)().default(null).nullable().label('Data Final Digitação Recuperação'),
});
exports.schemaPeriodoEtapa = exports.yupPeriodoEtapa.shape({});
